module.exports = __webpack_public_path__ + "static/ar-123cc535b35293562902f56512fd0f75.png";